<template>
  <div class="container-fluid mt-4">
    <b-card v-if="userIsLoggedIn">
      <b-card-header style="height: 75px;">
        <b-row>
        <b-col lg="9">
          <h1 class="h1">{{ dataConfig.title }}</h1>
        </b-col>
        <b-col lg="3">
          <b-alert style="margin-top: 5px;" :show="loading" variant="info">Lädt Daten...</b-alert>
        </b-col>
        </b-row>
      </b-card-header>
      <b-row>
        <b-col lg="12">
          <datatable :DataConfig="dataConfig" v-bind="$data" />
        </b-col>
        <b-col lg="4" style="display: flex;">
          <!--<b-alert :show="loading" variant="info">Lädt Daten...</b-alert>-->
          <b-card :title="'Patient über Datei hinzufügen'">
            <input style="padding-bottom: 10px;" type="file" ref="file" id="input"/>
            <b-btn v-on:click="loadTextFromFile()">Vorschau laden</b-btn>
          </b-card>
          <b-alert style="margin-top: 5px; margin-bottom: 5px;" :show="loading" variant="info">Lädt Daten...</b-alert>
        </b-col>
        <b-col v-if="showPreview" lg="12">
          <b-card :title="'Vorschau (max. 20 Zeilen)'">
            <b-btn v-on:click="uploadPatientFile()">Daten hochladen</b-btn>
            <b-btn v-on:click="deleteDataPreview()">Daten verwerfen</b-btn>
            <div v-if="warnings.length" style="margin: 5px;">
              <p class="text-warning" v-for="(warn, ind) in warnings" :key="ind" v-html="warn" />
                <information
                  :info-text="`Mögliche Kategorien sind: ${headerLabels.join(', ')}`"
                />
            </div>
            <ul class="nav nav-tabs">
              <li v-for="name in sheetOptions" :key="name">
                <a @click="dataSetName=name"> <b-nav-item> {{ name }} </b-nav-item> </a>
              </li>
            </ul>
            <datatable
              :data="previewData.slice(0, 20)"
              :columns="previewColumns"
              :query="{ limit: 20, offset: 0, sort: 'day_id', order: 'ASC', freeTextFilters: {}, assocFilters: {} }"
              :total="previewData.length"
              :HeaderSettings="false"
              :Pagination="false"
              :Export="false"
            />
          </b-card>
        </b-col>
        <b-col lg="12" style="margin-top: 20px;">
          <akribes-form
            :dataConfig="dataConfig"
            :containsImages="true"
            :routeID="routeID"
          />
        </b-col>
      </b-row>
    </b-card>
    <div v-else>
      <NotLoggedIn v-if="!loading" />
    </div>
  </div>
</template>

<script>
import config from '../config.json'
import api from '@/api'
import tableMixins from '../mixins/table_mixins'
import helpers from '@/mixins/helper-functions'
// import readXlsxFile from 'read-excel-file'
import xlsx from 'xlsx'
import NotLoggedIn from './NotLoggedIn'
import AkribesForm from './plugins/AkribesForm'
import Information from './plugins/Information'

export default {
  name: 'show-data',
  components: {
    NotLoggedIn,
    FilterTh: () => import('./plugins/th-Filter'),
    'akribes-form': AkribesForm,
    'information': Information
  },
  mixins: [tableMixins],
  data () {
    return {
      columns: [],
      data: [],
      total: 0,
      query: { limit: 20, offset: 0, sort: 'day_id', order: 'ASC', freeTextFilters: {}, assocFilters: {}, nChanges: 0 },
      pageSizeOptions: [5, 10, 20, 50, 100, 200],
      Export: true,
      dataConfig: config.tab_settings.patient,
      headerLabels: config.tab_settings.patient.tableHeader.map(head => head.label),
      categoryNames: config.tab_settings.patient.tableHeader.filter(head => head.input_type === 'Array').map(head => head.db_key),
      newPatients: [],
      categories: {},
      germanToEnglish: {},
      exceptionCategories: [
        'Heilende Wunde (klinisch)',
        'Nicht heilende Wunde (klinisch)',
        'Foto wurde gemacht?',
        'Heilende Wunde (in vitro)',
        'Nicht heilende Wunde (in vitro)'
      ],
      dbBooleanColumns: [
        'smell',
        'pain',
        'infection',
        'healing',
        'photo_exists',
        'healing_in_vitro'
      ],
      dbColumns: [
        'gender',
        'patient_id',
        'date',
        'day_id',
        'day_nr',
        'age',
        'allergies',
        'diagnose',
        'wound_localization',
        'wound_diameter',
        'wound_area',
        'wound_depth',
        'wound_volume',
        'other_colors',
        'bacteria',
        'not_healing_since',
        'photo_time',
        'photo_path',
        'wound_supply',
        'comment',
        'exudat_amount_swabs'
      ], // Columns in database
      woundImage: '',
      sheetNames: [],
      experimentName: 'patient'
    }
  },
  async created () {
    if (this.userIsLoggedIn) {
      var categoryLists = await api.getCategoryLists(this.categoryNames)
      this.categories = categoryLists
    }
    this.germanToEnglish = helpers.germanToEnglish(this.dataConfig)
  },
  computed: {
    file () {
      return this.$refs.file
    },
    routeID () {
      return this.$route.params.id
    }
  },
  methods: {
    async refreshPosts () {
      this.loading = true
      const config = this.dataConfig
      try {
        var response = await api.getPosts('patient', this.query)
      } catch (err) {
        console.log(err)
        this.loading = false
        return
      }
      if (typeof response === 'object') { // typeof response === 'string' if not logged in -> throws error
        var dbData = response.result
        var columns = response.columns
        var getFilterType = this.getFilterType
        var categories = this.categories
        var query = this.query
        this.columns = config.tableHeader.map(function (header, idx) {
          var isVisible = helpers.columnIsVisible(columns, header.db_key, header.visible, query.assocFilters.medication)
          return {
            title: header.label,
            field: header.db_key,
            visible: isVisible,
            isChecked: isVisible,
            category: header.category,
            sortable: !['Array', 'Assocs'].includes(header.input_type),
            thComp: (['Image', 'Time', 'Assocs'].includes(header.input_type)) ? '' : 'FilterTh',
            filterType: getFilterType(header.input_type),
            items: categories[header.db_key]
          }
        })
        this.data = dbData.rows
        this.total = dbData.count
      }
      this.loading = false
    },
    async uploadPatientFile () {
      this.loading = true
      var inputRows = [].concat.apply([], Object.values(this.xlsxInput))
      var patientResponse = await api.createPosts('patient', inputRows)
      helpers.createUploadFeedback(patientResponse)
      this.newPatients = []
      this.xlsxInput = {}
      await this.refreshPosts()
      this.deleteDataPreview()
      this.loading = false
    },
    getFilterType (inputType) {
      return (['Boolean', 'Date', 'ComputedDate', 'Array', 'Number', 'ComputedNumber'].includes(inputType)) ? inputType : 'FreeText'
    },
    convertRowsToFormedInput (rows, name) {
      const that = this
      var engCategory
      const nMeasurements = rows[0].filter(row => row).length // Count not-nulls in first row
      const inputCategories = rows.map(row => row[1])
      inputCategories[0] = 'Tages-ID'
      inputCategories[1] = 'Tag'
      const configCategories = that.dataConfig.tableHeader.map(head => head.label)
      for (var i = 0; i < nMeasurements; i++) { // Iterate over measurement columns
        var formedInput = {}
        that.categoryNames.forEach(cat => {
          formedInput[cat] = []
        })
        rows.forEach((row, rowInd) => { // Iterate over measured values
          var inputCategory = inputCategories[rowInd]
          if (inputCategory) inputCategory = inputCategory.trim()
          var value = row[2 + i] // Two description columns, then measurement columns
          var isX = false
          if (typeof value === 'string') {
            value = value.trim()
            isX = value.toLowerCase() === 'x'
          }

          // Add to Formed Input
          if (isX && that.exceptionCategories.includes(inputCategory)) {
            // engCategory expected to contain Boolean values
            engCategory = that.germanToEnglish[helpers.capitalizeFirstLetter(inputCategory.replace('Nicht ', ''))]
            if (!that.dbBooleanColumns.includes(engCategory)) {
              that.warnings.push(`Tab ${name}, ID ${formedInput.day_id} - Problem bei <b>${inputCategory}</b>: Unerwarteter Input "${value}"`)
              console.log('Problem 1')
            }
            formedInput[engCategory] = !inputCategory.includes('Nicht')
          } else if (isX) {
            var revSubRow = JSON.parse(JSON.stringify(inputCategories.slice(0, rowInd))).reverse()
            var valueCategory = revSubRow.find(cat => configCategories.includes(cat))
            engCategory = that.germanToEnglish[valueCategory]

            // Test if category and input is valid
            if ((!that.headerLabels.includes(inputCategory) && !that.categories[engCategory])) {
              that.warnings.push(`Tab ${name}, ID ${formedInput.day_id} - Problem bei <b>${inputCategory}</b>: Unerwarteter Input "${value}"`)
              console.log('Problem 2')
            } else {
              if (that.categoryNames.includes(engCategory)) {
                if (typeof formedInput[engCategory] === 'string') formedInput[engCategory] = formedInput[engCategory].split()
                formedInput[engCategory].push(inputCategory)
              } else {
                if (that.dbBooleanColumns.includes(engCategory)) {
                  that.warnings.push(`Tab ${name}, ID ${formedInput.day_id} - Problem bei <b>${inputCategory}</b>: Unerwarteter Input "${value}", erwartet: J/N`)
                  console.log('Problem 3')
                } else if (!that.dbColumns.includes(engCategory)) {
                  that.warnings.push(`Tab ${name}, ID ${formedInput.day_id} - Problem bei <b>${inputCategory}</b>: Unerwarteter Input "${value}"`)
                  console.log('Problem 4')
                }
                formedInput[engCategory] = inputCategory
              }
            }
          } else if (value || value === 0) {
            engCategory = that.germanToEnglish[inputCategory]

            // Test if category and input is valid
            if (inputCategory && !that.headerLabels.includes(inputCategory)) {
              that.warnings.push(`Tab ${name}, ID ${formedInput.day_id} - Problem bei <b>${inputCategory}</b>: Unerwarteter Input "${value}" oder unerwartete Kategorie`)
              console.log('Problem 5')
            } else if (['medication', 'comorbidity'].includes(engCategory)) {
              formedInput[engCategory] = value.split(', ')
            } else {
              if (['day_nr', 'age'].includes(engCategory)) {
                value = Math.round(value)
              }
              if (!'jJnN'.includes(value)) {
                // engCategory expected to be a dbColumn
                if (inputCategory && !that.dbColumns.includes(engCategory)) {
                  that.warnings.push(`Tab ${name}, ID ${formedInput.day_id} - Problem bei <b>${inputCategory}</b>: Unerwarteter Input "${value}"`)
                  console.log('Problem 6')
                }
              }
              formedInput[engCategory] = ('jJnN'.includes(value) && this.dbBooleanColumns.includes(engCategory)) ? ('jJ'.includes(value)) : '' + value
            }
          }
        })
        if (formedInput.gender) formedInput.gender = [formedInput.gender]
        if (formedInput.photo_time) { // parses wrong time, for some reasons ...
          var wrongTime = new Date(Math.ceil(parseFloat(formedInput.photo_time) * 1000 * 60 * 60 * 24))
          var hours = wrongTime.getHours()
          formedInput.photo_time = new Date(wrongTime.setHours(hours - 1))
        }

        // Excel saves dates as (number of days after 1.1.1900) + 2
        let dbDate = new Date('12-30-1899')
        dbDate.setDate(dbDate.getDate() + parseInt(formedInput.date))
        formedInput.date = dbDate

        delete formedInput.undefined
        that.newPatients.push(formedInput)
      }
      that.xlsxInput[name] = that.newPatients
      that.newPatients = []
    },
    async loadTextFromFile () {
      // File has a complicated format, thus it needs a complex method to read it
      this.loading = true
      const input = this.file.files[0]
      const convertRowsToFormedInput = this.convertRowsToFormedInput
      const that = this

      const reader = new FileReader()
      reader.onload = function (e) {
        const bstr = e.target.result
        const workBook = xlsx.read(bstr, { type: 'binary' })
        this.sheetNames = workBook.SheetNames
        this.sheetNames.forEach(name => {
          const workSheet = workBook.Sheets[name]
          var rows = xlsx.utils.sheet_to_json(workSheet, { header: 1 })
          while (JSON.stringify(rows.map(row => row[0])) === JSON.stringify(rows.map(row => row[1]))) {
            rows = rows.map(row => row.slice(1))
          }
          convertRowsToFormedInput(rows, name)
        })
        that.createDataPreview(that.xlsxInput)
      }
      reader.readAsBinaryString(input)
      this.loading = false
    }
  },
  watch: {
    async userIsLoggedIn (u) {
      if (u) {
        var categoryLists = await api.getCategoryLists(this.categoryNames)
        this.categories = categoryLists
      }
    }
  }
}
</script>

<style>
.date-control {
  border-radius: 4px;
}
.input-control {
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Patient.vue